module.exports = __webpack_public_path__ + "img/exp__1.5ac064e7.jpg";